import { Grid } from '@mui/material';
import React from 'react';
import GameSlider from './Games/GameSlider';
import MostViewGames from './Games/MostViewGames';
import NewRelease from './Games/NewRelease';
import PopularGames from './Games/PopularGames';
import TopRating from './Games/TopRating';
import Trending7Days from './Games/Trending7Days.js';
import NavBar from './NavBar/NavBar';
import TopReview from './Games/TopReview';
const GamesPage = () => {
  return (
    <Grid container>
        <Grid item lg={2} md={2} xl={2}>
            <NavBar />
        </Grid>
        <Grid item lg={8} md={8} xl={8}>
            <Grid container>
                <Grid xs={12} sm={12} md={12} lg={12} xl={12}>
                    <GameSlider />
                </Grid>
                <Grid xs={12} sm={12} md={12} lg={12} xl={12}>
                    <PopularGames />
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                    <NewRelease />
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                    <MostViewGames />
                </Grid>
            </Grid>
        </Grid>
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <Trending7Days />
        </Grid>
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <TopRating />
        </Grid>
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <TopReview />
        </Grid>
    </Grid>
  );
};

export default GamesPage;